import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { TeachingHallFilters } from '../../../lib/types/models/ol/teaching-hall/teaching-hall-filters'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTeachingHalls(olId: number, input?: PaginationRequest<TeachingHallFilters>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.ols.getTeachingHalls.url, { olId }),
        input
      )
    )
    .get<PaginationResponse<TeachingHall>>()
}
